import React, { useState, useEffect } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import clientAxios from '../../clients/clientAxios';
import { notify } from 'react-notify-toast';

export default function EditCurso({ show, onHide, curso, onSave }) {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    durationMonths: '',
    modulesCount: '',
    fullDescription: '',
    videoUrl: '',
    enable: true,
  });
  const [isSaving, setIsSaving] = useState(false);

  const headerConfig = {
    headers: { 'auth-token': localStorage.getItem('JWT') || ' ' },
  };

  useEffect(() => {
    if (curso && show) {
      setFormData({
        name: curso.name || '',
        description: curso.description || '',
        durationMonths: curso.durationMonths || '',
        modulesCount: curso.modulesCount || '',
        fullDescription: curso.fullDescription || '',
        videoUrl: curso.videoUrl || '',
        enable: curso.enable !== undefined ? curso.enable : true,
      });
    }
  }, [curso, show]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value.trim(),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name) {
      notify.show('El nombre del curso es requerido', 'error');
      return;
    }

    if (!curso?._id) {
      notify.show('Error: ID del curso no encontrado', 'error');
      return;
    }

    setIsSaving(true);

    try {
      const payload = {
        ...formData,
        durationMonths: formData.durationMonths
          ? parseInt(formData.durationMonths, 10)
          : undefined,
        modulesCount: formData.modulesCount
          ? parseInt(formData.modulesCount, 10)
          : undefined,
      };

      await clientAxios.put(
        `/courses/${curso._id}`,
        payload,
        headerConfig
      );
      notify.show('Curso actualizado correctamente', 'success');
      onSave();
    } catch (err) {
      notify.show(
        err?.response?.data?.message || 'Error al actualizar el curso',
        'error'
      );
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal centered show={show} onHide={onHide} size='lg'>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Curso</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className='mb-3'>
            <Form.Label>
              Nombre del Curso <span className='text-danger'>*</span>
            </Form.Label>
            <Form.Control
              type='text'
              name='name'
              value={formData.name}
              onChange={handleChange}
              placeholder='Ej: Testing QA'
              required
            />
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Descripción corta</Form.Label>
            <Form.Control
              as='textarea'
              name='description'
              value={formData.description}
              onChange={handleChange}
              placeholder='Breve descripción del curso'
              rows={2}
            />
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Duración (meses)</Form.Label>
            <Form.Control
              type='number'
              name='durationMonths'
              value={formData.durationMonths}
              onChange={handleChange}
              placeholder='Ej: 2'
              min='1'
            />
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Cantidad de módulos</Form.Label>
            <Form.Control
              type='number'
              name='modulesCount'
              value={formData.modulesCount}
              onChange={handleChange}
              placeholder='Ej: 5'
              min='1'
            />
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Descripción completa (HTML)</Form.Label>
            <Form.Control
              as='textarea'
              name='fullDescription'
              value={formData.fullDescription}
              onChange={handleChange}
              placeholder='Descripción detallada del curso'
              rows={3}
            />
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>URL del video (YouTube embed)</Form.Label>
            <Form.Control
              type='text'
              name='videoUrl'
              value={formData.videoUrl}
              onChange={handleChange}
              placeholder='Ej: https://www.youtube.com/embed/...'
            />
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Check
              type='checkbox'
              name='enable'
              label='Habilitar curso'
              checked={formData.enable}
              onChange={handleChange}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant='secondary' onClick={onHide} disabled={isSaving}>
            Cerrar
          </Button>
          <Button variant='primary' type='submit' disabled={isSaving}>
            {isSaving ? 'Guardando...' : 'Guardar cambios'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
